export const LOCATION_AREA_TYPE = 0;
export const RATE_ZONE_AREA_TYPE = 1;
export const POSTAL_CODE_AREA_TYPE = 2;

export const PICKUP_ZONE_TYPE = 1;

export const DRAFT_STATUS = 0;
export const PRESENTED_STATUS = 1;
export const ACCEPTED_STATUS = 2;
export const CANCELLED_STATUS = 4;
export const MANAGEMENT_APPROVAL_REQUIRED_STATUS = 5;
export const DELIVERY_RATE_ZONE_TYPE = 0;
export const PICKUP_RATE_ZONE_TYPE = 1;
